<template>
  <div>
    <router-view></router-view>
    <div v-if="hasError">
      Could not create claim. Please contact .... for help
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data: () => ({
    hasError: false
  }),
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  created() {
    this.init(this.id);
  },
  methods: {
    async init(id) {
      const { commit, dispatch } = this.$store;

      commit('SET_SPINNER', true);

      if (!this.isAuthenticated) {
        await dispatch('AUTHENTICATE', id).catch((e) => {
          commit('RESET_STATE');
          this.$router.push({ name: 'start' });
          commit(
            'SET_ERROR',
            e.data && e.data.responseStatus ? e.data.responseStatus.message : ''
          );
        });
      }

      if (this.isAuthenticated) await this.start();
    },
    async start() {
      const { commit, dispatch } = this.$store;

      try {
        dispatch('GET_CLAIM_CATEGORIES');
        await dispatch('CREATE_CLAIM');
        await dispatch('GET_CLAIM', this.$store.state.claim.id);
      } catch (e) {
        commit('SET_ERROR', e);
      } finally {
        commit('SET_SPINNER', false);
        this.$router.push({ name: 'select-category' });
      }
    }
  }
};
</script>
